module.exports = __webpack_public_path__ + "static/media/Home-active.1fe88f86.svg";